import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
/**
 * What the released seats were for. `kind` only decides how the fallback copy
 * reads when the thing has no name — an unnamed season is a real case, since
 * `Season.name` is nullable.
 */
export interface SessionExpirationDialogData {
  target: {
    name: string | null;
    kind: 'event' | 'season';
  };
}

@Component({
  selector: 'stx-ui-session-expiration-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatDialogModule],
  template: `
    <div matDialogTitle>Tu sesión ha expirado</div>
    <div matDialogContent>
      <p class="text-sm">
        Los asientos que seleccionaste para
        @if (target?.name; as name) {
          <span class="font-medium">{{ name }}</span>
        } @else if (target?.kind === 'season') {
          este abono
        } @else {
          este evento
        }
        han sido liberados para venta.
      </p>
      <p class="variant mt-2 text-sm">
        No te preocupes, puedes volver a seleccionar asientos para continuar con
        tu compra.
      </p>
    </div>
    <div
      matDialogActions
      align="end"
    >
      <button
        mat-flat-button
        mat-dialog-close
      >
        Seleccionar nuevos asientos
      </button>
    </div>
  `,
})
export class SessionExpirationDialogComponent {
  readonly dialogRef = inject(MatDialogRef<SessionExpirationDialogComponent>);
  readonly dialogData = inject<SessionExpirationDialogData | null>(
    MAT_DIALOG_DATA,
    { optional: true },
  );
  /** Narrowed once so the template reads it without guarding twice. */
  protected readonly target = this.dialogData?.target;
}
